(() => {
  if (window.__vmShopWithAiBound) return;
  window.__vmShopWithAiBound = true;

  const triggerSelector = '[data-vm-ai-open]';
  let appliedHideSetting = null;
  let resizeTimer = null;

  const pushToProvider = (entry) => {
    window.SmartBotEventLayer = window.SmartBotEventLayer || [];
    window.SmartBotEventLayer.push(entry);
  };

  const isVisible = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    const style = window.getComputedStyle(element);

    return (
      element.getClientRects().length > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  };

  const syncLauncherVisibility = () => {
    const headerTriggerAvailable = Array.from(
      document.querySelectorAll(triggerSelector)
    ).some(isVisible);

    if (headerTriggerAvailable === appliedHideSetting) return;
    appliedHideSetting = headerTriggerAvailable;

    pushToProvider(['config', { hideChatIcon: headerTriggerAvailable }]);
    document.documentElement.toggleAttribute(
      'data-vm-ai-header-ready',
      headerTriggerAvailable
    );
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    pushToProvider(['event', 'open_chat']);
  });

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(syncLauncherVisibility, 120);
  });

  window.addEventListener('pageshow', syncLauncherVisibility);
  document.addEventListener('shopify:section:load', syncLauncherVisibility);
  document.addEventListener('shopify:section:unload', syncLauncherVisibility);

  syncLauncherVisibility();
})();
